import { render, staticRenderFns } from "./InactivePropertyTable.vue?vue&type=template&id=d8e97f8c&"
import script from "./InactivePropertyTable.vue?vue&type=script&lang=js&"
export * from "./InactivePropertyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports